import * as Button from 'bootstrap/js/dist/button';
import * as Popover from 'bootstrap/js/dist/popover';
import * as Modal from 'bootstrap/js/dist/modal';
import * as Collapse from 'bootstrap/js/dist/collapse';

window.bootstrap = {
    Button,
    Popover,
    Modal,
    Collapse
}